/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from "react";
import { useTheme } from "../../theme/ThemeContext";

/**
 * Text Area to be used in Forms
 * @param {error, ...props} param0 
 * @returns 
 */
export default function ThemedTextArea({ error, ...props }) {
    const { theme } = useTheme();
    return (
        <textarea
            {...props}
            style={{
                border: `1.4px solid ${error ? "#d53b3b" : theme.primary}`,
                borderRadius: theme.buttonRadius,
                background: "#f8fafc",
                color: theme.text,
                fontFamily: "inherit",
                width: "100%",
                padding: "8px 11px",
                outline: "none"
            }}
            className={props.className}
        />
    );
}
